import type { Partnership } from './types';

const items = import.meta.glob<Partnership>('./partnerships/*.json', { eager: true, import: 'default' });
const bodies = import.meta.glob<string>(['./partnerships/*.html', '!./partnerships/*.resources.html'], {
  query: '?raw',
  import: 'default',
});
const resources = import.meta.glob<string>('./partnerships/*.resources.html', { query: '?raw', import: 'default' });

export const partnerships: Partnership[] = Object.values(items).sort((a, b) => a.slug.localeCompare(b.slug));

export const getPartnership = (slug: string) => partnerships.find((p) => p.slug === slug);

export async function loadPartnershipBody(slug: string): Promise<{ body: string; resources: string }> {
  const [body, res] = await Promise.all([
    bodies[`./partnerships/${slug}.html`]?.(),
    resources[`./partnerships/${slug}.resources.html`]?.(),
  ]);
  return { body: body ?? '', resources: res ?? '' };
}
